module.exports = __webpack_public_path__ + "media/images/elements/Elemntas_6-ba18ed3400999eb9cb7668243e1d9e25.svg";